<template lang="pug">
  v-navigation-drawer(
    v-if="isRenderDrawerMenu"
    :value="value",
    v-bind="$attrs",
    v-on="$listeners",
    fixed,
    right,
    temporary,
    :expand-on-hover="true"
    light,
    ref="drawer"
  )
    .mobile-menu(ref="menu")
      .mobile-menu-profile(v-show="isLoggedIn")
        router-link.menu-item.user-picture-link(
          :to="{ name: 'profile' }"
        )
          UserPicture.small-avatar
          span {{ profileFullName }}
        NavigationDrawerMenuItem(
          key="investments"
          name="Portfolio"
          path="/profile/investments"
          slug="investments"
          :is-notification="Boolean(investmentProfileAccreditationIssueList.length)"
          :show-icon="false"
        )
        NavigationDrawerMenuItem(
          key="accounts"
          name="Accounts"
          path="/profile/accounts"
          slug="accounts"
          :is-notification="!isSomeInvestmentProfileVerified"
          :show-icon="false"
        )
        NavigationDrawerMenuItem(
          key="wallet"
          name="Wallet"
          path="/profile/wallet"
          slug="wallet"
          :is-notification="!isSomeInvestmentProfileVerified"
          :show-icon="false"
        )
        NavigationDrawerMenuItem(
          key="notifications"
          name="Notifications"
          path="/profile/notifications"
          slug="notifications"
          :show-icon="false"
        )
          span.new-notifiction-count(
            v-show="notificationsAllNew > 0"
            slot="name-info"
          ) {{ notificationsAllNew }}
        NavigationDrawerMenuItem(
          key="settings"
          name="Settings"
          path="/profile/settings"
          slug="settings"
          :show-icon="false"
        )
      NavigationDrawerMenuItem(
        v-for="item in headerMenuChildren"
        :key="item.slug"
        v-bind="item"
      )
    .btn-row(:class="{'is-logged-in': isLoggedIn}")
      router-link.link-2(
        v-if="!isLoggedIn"
        to="/sign-in",
      ) Log In
      v-btn(
        v-if="!isLoggedIn"
        color="primary",
        to="/sign-up",
        small,
      ) Sign Up
      v-btn(
        v-if="isLoggedIn"
        color="primary",
        @click="logout",
        small,
      ) Logout
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { VNavigationDrawer } from 'vuetify/lib';
import { HEADER_MENU, PROFILE_MENU } from 'Config/menu';
import UserPicture from 'Components/UserPicture/UserPicture';
import SolidBellIcon from 'images/svg-icons/solid-bell.svg';
import { scrollToTop } from 'Helpers/utils/view';
import NavigationDrawerMenuItem from './NavigationDrawerMenuItem';

export default {
  name: 'NavigationDrawerMenu',
  components: {
    VNavigationDrawer,
    NavigationDrawerMenuItem,
    UserPicture,
    SolidBellIcon,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      isRenderDrawerMenu: false,
    };
  },
  computed: {
    ...mapGetters('login', [
      'isLoggedIn',
    ]),
    ...mapGetters('notifications', [
      'notificationsAllNew',
    ]),
    ...mapGetters('profile', [
      'profileModel',
      'profileFullName',
      'isStatusVerified',
      'isBeneficialOwnersFormActionRequired',
      'isAccredited',
      'isSomeInvestmentProfileVerified',
      'investmentProfileAccreditationIssueList',
    ]),
    isOpenMenu() {
      return this.$refs.drawer ? this.$refs.drawer.showOverlay : this.value;
    },
    userFullName() {
      return `${this.profileModel.first_name} ${this.profileModel.last_name}`;
    },
  },
  watch: {
    value(value) {
      if (value) {
        this.isRenderDrawerMenu = true;
      }
    },
    isOpenMenu() {
      const { body } = document;
      if (this.isOpenMenu) {
        body.classList.add('is-mobile-menu-open');
      } else {
        body.classList.remove('is-mobile-menu-open');
        this.$emit('closed-menu');
        if (this.$refs.drawer && this.$refs.drawer.$el.children[0]) scrollToTop(0, this.$refs.drawer.$el.children[0]);
      }
    },
  },
  mounted() {
    // set timeout to render drawer menu
    setTimeout(() => {
      this.isRenderDrawerMenu = true;
    }, 2000);
  },
  methods: {
    ...mapActions('login', [
      'logout',
    ]),
  },
  staticData: {
    profileMenu: PROFILE_MENU,
    headerMenuChildren: HEADER_MENU.children,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.v-navigation-drawer
  padding-top: 64px !important
  height: 100% !important
  overflow: hidden
  pointer-events: none
  z-index: 9
  ::v-deep .v-navigation-drawer__content
    width: 100%
    -webkit-overflow-scrolling: touch
    pointer-events: auto
  .mobile-menu
    display: flex
    flex-direction: column
    overflow: hidden
    padding-left: 20px
    height: auto
    -webkit-overflow-scroll: touch
    padding-top: 10px
    padding-bottom: 65px
    .new-notifiction-count
      font-size: 8px
      color: $secondary
      line-height: 10px
    &-profile
      .menu-item
        padding-top: 0
        padding-bottom: 0
        &:not(.user-picture-link)
          padding-left: 30px
          font-family: $font-medium
          font-weight: 500
        &:not(:last-child)
          &:after
            border-bottom: none
        &:last-child
          ::v-deep .icon
            margin-bottom: 8px
          ::v-deep .menu-item__name
            margin-bottom: 7px
        &.user-picture-link
          display: flex
          flex-direction: row
          align-items: center
          padding-top: 15px
          padding-bottom: 15px
          span
            font-size: 14px
            margin-left: 15px
      .small-avatar
        width: 14px
        height: 14px
        font-size: 7px
        position: relative
        ::v-deep .img
          background-size: cover
          width: 100%
          height: 100%
        &:not(.is_image)
          box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.05)
          ::v-deep .img
            background-size: contain
            width: 8px
            height: 8px
            transform: none
  &--open
    width: 255px !important
  .btn-row
    width: 100%
    border-top: 1px solid $support_lightgray
    position: absolute
    background-color: $white
    left: 0
    bottom: 0px
    z-index: 3
    padding-top: 15px
    padding-bottom: 20px
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    .link-2
      margin-left: 15px
      font-size: 14px
    .v-btn
      width: 82px
      margin-left: 40px
      box-shadow: none
    &.is-logged-in
      justify-content: center
      .v-btn
        width: 100%
        max-width: 213px
        margin-left: 0
  ::v-deep .v-navigation-drawer__border
    display: none
</style>
